import { Stack } from "@chakra-ui/react";
import { Button } from "components/Button";
import BadgeComp from "components/RFQ/BadgeComp/BadgeComp";
import { isRFQDraft } from "utils/helpers";
import { RFX_TABS } from "utils/constants";
const RFQDetailButtonTab = ({
	rfqDetail,
	currentTab,
	setCurrentTab,
	totalAddendumAndComms,
}) => {
	const { accepted, all, submitted, declined } = rfqDetail?.supplierInvited || {
		accepted: [],
		all: [],
		declined: [],
		submitted: [],
	};

	const isDraft = isRFQDraft(rfqDetail?.status);
	const tabMenu = [
		{
			id: RFX_TABS.ALL_INVITED_SUPPLIER,
			name: isDraft ? "Suppliers" : "All Invited Suppliers",
			showBadge: true,
			total: all?.length || 0,
		},
		{
			id: RFX_TABS.ACCEPTED,
			name: "Accepted",
			showBadge: true,
			total: accepted?.length || 0,
		},
		{
			id: RFX_TABS.DECLINED,
			name: "Declined",
			showBadge: true,
			total: declined?.length || 0,
		},
		{
			id: RFX_TABS.SUBMITTED,
			name: "Submitted",
			showBadge: true,
			total: submitted?.length || 0,
		},
		{
			id: RFX_TABS.COMMS,
			name: "Comms",
			showBadge: true,
			total: totalAddendumAndComms?.totalComms || 0,
		},
		{
			id: RFX_TABS.ADDENDUMS,
			name: "Addendum",
			showBadge: true,
			total: totalAddendumAndComms?.totalAddendum || 0,
		},
	];

	return (
		<Stack
			direction={{ base: "column", sm: "row" }}
			w="full"
			gap={2}
			align={{ base: "stretch", md: "center" }}
			wrap="wrap"
		>
			{tabMenu.map((tbMenu, index) => {
				return (
					<Button
						key={tbMenu.id}
						btntype="tab"
						active={currentTab === tbMenu.id ? true : false}
						onClick={() => setCurrentTab(tbMenu.id)}
						w={{ base: "full", sm: "auto" }}
						justifyContent="flex-start"
						className={`font-roboto font-medium text-${currentTab === tbMenu.id ? "to-utility-brand-700" : "text-gray-text-400"}`}
					>
						{tbMenu.name}
						{tbMenu.showBadge && (
							<BadgeComp
								title={tbMenu.id}
								active={currentTab}
								total={tbMenu.total}
							></BadgeComp>
						)}
					</Button>
				);
			})}
		</Stack>
	);
};

export default RFQDetailButtonTab;
